import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../profile/styles.css';

function AccordionSection({ sectionKey, title, openSections, onToggle, children }) {
  return (
    <section className="artist-help-category__card artist-help-category__accordion">
      <button
        type="button"
        className="artist-help-category__accordion-trigger"
        onClick={() => onToggle(sectionKey)}
        aria-expanded={openSections[sectionKey]}
      >
        <h2>{title}</h2>
        <span
          className={`artist-help-category__accordion-icon ${openSections[sectionKey] ? 'open' : ''}`}
          aria-hidden
        />
      </button>

      {openSections[sectionKey] && (
        <div className="artist-help-category__accordion-content">
          {children}
        </div>
      )}
    </section>
  );
}

export default function ProfileArtistHelpSuarteFeaturesPage() {
  const t = useTranslations('artist_help.suarte_features');
  const [openSections, setOpenSections] = useState({
    board: false,
    digitalCertificate: false,
    thoughts: false,
    ratings: false,
    suarteworld: false,
    community: false,
    likes: false,
    storyTold: false,
    inspiring: false,
    artistAiProfile: false,
    artworkAi: false,
    offers: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category">
      <header className="artist-help-category__header">
        <GoBackButton alternativeRoute="/profile/artist-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body">
        <AccordionSection
          sectionKey="board"
          title={t('sections.board.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.board.intro_p1')}</p>

          <div className="artist-help-category__stack">
            <h3>{t('sections.board.posts_title')}</h3>
            <p>{t('sections.board.posts_p1')}</p>
            <ul>
              <li>{t('sections.board.posts_list_1')}</li>
              <li>{t('sections.board.posts_list_2')}</li>
              <li>{t('sections.board.posts_list_3')}</li>
              <li>{t('sections.board.posts_list_4')}</li>
            </ul>
            <p>{t('sections.board.posts_p2')}</p>
          </div>

          <div className="artist-help-category__stack">
            <h3>{t('sections.board.articles_title')}</h3>
            <p>{t('sections.board.articles_p1')}</p>
            <ul>
              <li>{t('sections.board.articles_list_1')}</li>
              <li>{t('sections.board.articles_list_2')}</li>
              <li>{t('sections.board.articles_list_3')}</li>
              <li>{t('sections.board.articles_list_4')}</li>
            </ul>
            <p>{t('sections.board.articles_p2')}</p>
          </div>

          <div className="artist-help-category__stack">
            <h3>{t('sections.board.recommended_title')}</h3>
            <p>{t('sections.board.recommended_p1')}</p>
            <p>{t('sections.board.recommended_p2')}</p>
            <ul>
              <li>{t('sections.board.recommended_list_1')}</li>
              <li>{t('sections.board.recommended_list_2')}</li>
              <li>{t('sections.board.recommended_list_3')}</li>
            </ul>
          </div>
        </AccordionSection>

        <AccordionSection
          sectionKey="digitalCertificate"
          title={t('sections.digital_certificate.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.digital_certificate.p1')}</p>
          <p>{t('sections.digital_certificate.p2')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="thoughts"
          title={t('sections.thoughts.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.thoughts.p1')}</p>
          <p>{t('sections.thoughts.p2')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="ratings"
          title={t('sections.ratings.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.ratings.p1')}</p>
          <p>{t('sections.ratings.p2')}</p>
          <ul>
            <li>{t('sections.ratings.list_1')}</li>
            <li>{t('sections.ratings.list_2')}</li>
            <li>{t('sections.ratings.list_3')}</li>
          </ul>
          <p>{t('sections.ratings.p3')}</p>
          <p>{t('sections.ratings.p4')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="suarteworld"
          title={t('sections.suarteworld.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.suarteworld.p1')}</p>
          <p>{t('sections.suarteworld.p2')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="community"
          title={t('sections.community.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.community.p1')}</p>
          <p>{t('sections.community.p2')}</p>
          <p>{t('sections.community.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="likes"
          title={t('sections.likes.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.likes.p1')}</p>
          <ul>
            <li>{t('sections.likes.list_1')}</li>
            <li>{t('sections.likes.list_2')}</li>
            <li>{t('sections.likes.list_3')}</li>
            <li>{t('sections.likes.list_4')}</li>
            <li>{t('sections.likes.list_5')}</li>
          </ul>
          <p>{t('sections.likes.p2')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="storyTold"
          title={t('sections.story_told.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.story_told.p1')}</p>
          <p>{t('sections.story_told.p2')}</p>
          <p>{t('sections.story_told.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="inspiring"
          title={t('sections.inspiring.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.inspiring.p1')}</p>
          <p>{t('sections.inspiring.p2')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="artistAiProfile"
          title={t('sections.artist_ai_profile.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.artist_ai_profile.p1')}</p>
          <p>{t('sections.artist_ai_profile.p2')}</p>
          <p>{t('sections.artist_ai_profile.p3')}</p>
          <p>{t('sections.artist_ai_profile.p4')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="artworkAi"
          title={t('sections.artwork_ai.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.artwork_ai.p1')}</p>
          <p>{t('sections.artwork_ai.p2')}</p>
          <p>{t('sections.artwork_ai.p3')}</p>
        </AccordionSection>

        <AccordionSection
          sectionKey="offers"
          title={t('sections.offers.title')}
          openSections={openSections}
          onToggle={toggleSection}
        >
          <p>{t('sections.offers.p1')}</p>

          <div className="artist-help-category__stack">
            <h3>{t('sections.offers.admin_title')}</h3>
            <ul>
              <li>{t('sections.offers.admin_list_1')}</li>
              <li>{t('sections.offers.admin_list_2')}</li>
              <li>{t('sections.offers.admin_list_3')}</li>
            </ul>
          </div>

          <div className="artist-help-category__stack">
            <h3>{t('sections.offers.send_steps_title')}</h3>
            <ul>
              <li>{t('sections.offers.send_steps_list_1')}</li>
              <li>{t('sections.offers.send_steps_list_2')}</li>
              <li>{t('sections.offers.send_steps_list_3')}</li>
              <li>{t('sections.offers.send_steps_list_4')}</li>
            </ul>
          </div>

          <div className="artist-help-category__note">
            <h3>{t('sections.offers.important_title')}</h3>
            <p>{t('sections.offers.important_p1')}</p>
          </div>

          <div className="artist-help-category__stack">
            <h3>{t('sections.offers.next_title')}</h3>
            <p>{t('sections.offers.next_p1')}</p>
          </div>
        </AccordionSection>
      </div>
    </section>
  );
}
